/**
 * Created by sswaminathan on 11/29/21
 * File: AppReducer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css
import { LOAD_APPS } from './actions/AppReducer.actions'

/**
 *   TODO: Brief what is this component/class do
 */
const initialState = {
  supportedRegions: [],
  supportedRegionsByKey: {},
  domainPostFix: {},
  apps: {}
}

const getApps = (apps) => apps.reduce((object, app) => {
  object[app.app_id] = app
  return object
}, {})

const getRegionsByKey = (supportedRegions) => {
  const regionByKey = {}
  const domainPostFix = {}
  supportedRegions.forEach((elem) => {
    if (elem.domain_postfix) {
      domainPostFix[elem.app_id] = elem.domain_postfix
    }
    if (regionByKey[elem.app_id] && elem.regions) {
      regionByKey[elem.app_id] = [...regionByKey[elem.app_id], ...(getRegionObject(elem.regions))]
    }
    else if (elem.regions) {
      regionByKey[elem.app_id] = getRegionObject(elem.regions)
    }
  })
  return { regionByKey, domainPostFix }
}

const getRegionObject = (regionList) => {
  const regionDropDown = []
  regionList.forEach((elem) => {
    const regionObject = {
      'value': elem?.name,
      'description': elem?.display
    }
    regionDropDown.push(regionObject)
  })
  return regionDropDown
}

const AppReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_APPS: {
      const apps = { ...state.apps, ...getApps(action.apps) }
      const { regionByKey, domainPostFix } = getRegionsByKey(action.apps)
      return {
        ...state,
        apps,
        supportedRegions: action.apps,
        supportedRegionsByKey: regionByKey,
        domainPostFix: domainPostFix
      }
    }
    default: {
      return state
    }
  }
}

AppReducer.initialState = initialState
export default AppReducer
